module.exports = __webpack_public_path__ + "pic_bizny_web_05@2x.png?486a2c56ec85e7a12e37bc6690eaab70";